import Button from "@/components/button";
import { Input } from "@/components/form";
import { SIGNUP_ROUTE } from "@/helpers/routes";
import { Formik, FormikHelpers, FormikValues } from "formik";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

export function Step3Title() {
  return (
    <>
      <h2 className="text-4xl text-primary">Promo Information</h2>
      <p className="text-dark-grey mt-4">fill in your credentials</p>
    </>
  );
}

export default function Step3({
  setFormData,
  defaultData,
}: {
  defaultData: { [key: string]: string };
  setFormData: (values: any) => void;
}) {
  const navigate = useNavigate();

  const submit = useCallback<any>(
    async (
      values: FormikValues,
      { setErrors, setStatus, setSubmitting }: FormikHelpers<FormikValues>,
    ) => {
      try {
        setFormData(values);
        setSubmitting(false);
        setStatus({ success: true });

        navigate(`${SIGNUP_ROUTE}/4`);
      } catch (err: any) {
        setStatus({ success: false });
        setErrors({ submit: err.message || "Something went wrong" });
        setSubmitting(false);
      }
    },
    [setFormData],
  );

  return (
    <Formik
      initialValues={{
        password: defaultData?.password || "",
        cpassword: "",
        province: defaultData?.province || "",
        code: defaultData?.code || "",
        district: defaultData?.district || "",
        submit: null,
      }}
      validationSchema={Yup.object().shape({
        discount: Yup.string().nullable(),
        province: Yup.string().required("Province is required"),
        district: Yup.string().required("District is required"),
      })}
      onSubmit={submit}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => {
        return (
          <form
            method="post"
            className="flex flex-col gap-4 [&_input]:!rounded-xl"
            onSubmit={handleSubmit}
          >
            {errors.submit ? (
              <p className="text-red-500 -my-2">{errors.submit}</p>
            ) : (
              <p className="text-transparent select-none -my-2">error</p>
            )}



            <Input
              label="Your referrer code"
              name="code"
              type="text"
              placeholder="Enter your referrer code"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.code}
              error={errors.code}
              isTouched={touched.code}
              required
            />

            <Input
              label="Province"
              name="province"
              type="text"
              placeholder="Enter your province"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.province}
              error={errors.province}
              isTouched={Boolean(touched.province)}
              required
            />

            <Input
              label="District"
              name="district"
              type="text"
              placeholder="Enter your district"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.district}
              error={errors.district}
              isTouched={Boolean(touched.district)}
              required
            />


            {/* Submit Button */}
            <Button type="submit" className="!rounded-xl !py-3" disabled={isSubmitting}>
              {isSubmitting ? <>Please wait...</> : "Continue"}
            </Button>
          </form>
        );
      }}
    </Formik>
  );
}
